module.exports = __webpack_public_path__ + "static/img/draw-bg.29062fff.png";